import React from 'react';
import { Tab, Tabs } from '@material-ui/core';
import TabContext from '@material-ui/lab/TabContext';
import TabPanel from '@material-ui/lab/TabPanel';
import DataTable from './DataTable';
import NoData from '../../../../components/NoData';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import '../styles.scss';

export default function ExamTabPanel(props) {
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="tab-design">
      <TabContext value={value}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          className="line-tab"
        >
          <Tab label="Exam Attended" value="1" />
          <Tab label="Exam UnAttended" value="2" />
        </Tabs>
        <TabPanel value="1">
          {!isEmpty(props) && !isEmpty(props.presentData) ? (
            <DataTable
              testData={props.presentData}
              filteredKeys={props.filteredKeys}
              present={true}
              handleSolution={(val) => props.handleSolution(val)}
            />
          ) : (
            <div className="no-data-container">
              <NoData
                message={
                  'As of Now, No Attended Exams are available for you in Test Performance Analysis. Please come back later.'
                }
              />
            </div>
          )}
        </TabPanel>
        <TabPanel value="2">
          {!isEmpty(props) && !isEmpty(props.absentData) ? (
            <DataTable
              testData={props.absentData}
              filteredKeys={props.filteredKeys}
              present={false}
              handleSolution={(val) => props.handleSolution(val)}
            />
          ) : (
            <div className="no-data-container">
              <NoData
                message={
                  'As of Now, No Unattended Exams are available for you in Test Performance Analysis. Please come back later.'
                }
              />
            </div>
          )}
        </TabPanel>
      </TabContext>
    </div>
  );
}
ExamTabPanel.propTypes = {
  testData: PropTypes.object,
  present: PropTypes.bool,
  filteredKeys: PropTypes.object,
  handleSolution: PropTypes.func,
  absentData: PropTypes.bool,
  presentData: PropTypes.bool,
};
